import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "update-expense-modal"
}
const _hoisted_2 = {
  class: "flex w-full items-center justify-between",
  style: {"padding":"0px 5px 8px 5px","border-bottom":"1px solid #cfd8dc"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold" }, "Edit Solar Bon", -1)
const _hoisted_4 = { class: "content" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-grey" }, "Jadwal", -1)
const _hoisted_6 = { class: "text-2xl font-bold mb-4" }
const _hoisted_7 = { class: "rounded-xl border-grey-2 p-5 mb-4" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "col-span-4 flex flex-col" }
const _hoisted_10 = { class: "text-sm font-bold text-neutral-dark mb-1" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Lihat Detail ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-angle-right text-[10px]" }, null, -1)
const _hoisted_14 = [
  _hoisted_12,
  _hoisted_13
]
const _hoisted_15 = { class: "col-span-3" }
const _hoisted_16 = { class: "text-base font-bold text-neutral-dark" }
const _hoisted_17 = { class: "col-span-5" }
const _hoisted_18 = { class: "p-inputgroup" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon bg-neutral-100 text-xs font-bold w-12" }, "Rp.", -1)
const _hoisted_20 = {
  key: 1,
  class: "pl-4 text-sm text-neutral-500 italic"
}
const _hoisted_21 = { class: "flex items-center pt-5" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Kembali")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Simpan")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (!$setup.isLoading)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_Dialog, {
          class: "approve-modal",
          showHeader: true,
          visible: $setup.showModal,
          "onUpdate:visible": _cache[3] || (_cache[3] = ($event: any) => (($setup.showModal) = $event)),
          breakpoints: { '960px': '75vw', '640px': '90vw' },
          style: { width: '40vw' },
          modal: true,
          contentClass: "wrap-ctn-modal-default"
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", null, [
                _createElementVNode("i", {
                  class: "pi pi-times cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.closeDialog()))
                })
              ])
            ])
          ]),
          footer: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_Button, {
                class: "btn-back mr-2",
                onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.closeDialog()))
              }, {
                default: _withCtx(() => [
                  _hoisted_22
                ]),
                _: 1
              }),
              _createVNode(_component_Button, {
                class: "btn-primary",
                onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.onSubmit()))
              }, {
                default: _withCtx(() => [
                  _hoisted_23
                ]),
                _: 1
              })
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", _hoisted_6, _toDisplayString($setup.TrxId), 1),
              _createElementVNode("div", _hoisted_7, [
                ($setup.solarBonEditData && $setup.solarBonEditData.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.solarBonEditData, (solarBonItem, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "grid grid-cols-12 gap-3 mb-4 items-center"
                        }, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", _hoisted_10, _toDisplayString(solarBonItem.fuelStationPartnerName || '-'), 1),
                            _createElementVNode("a", {
                              href: "#",
                              class: "text-blue-500 hover:text-blue-600 text-xs font-semibold flex items-center gap-1",
                              onClick: _withModifiers(($event: any) => ($setup.navigateToFuelingDetail(solarBonItem.fuelingTransactionId)), ["prevent"])
                            }, _hoisted_14, 8, _hoisted_11)
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, _toDisplayString(solarBonItem.newLiters) + " L ", 1)
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createElementVNode("div", _hoisted_18, [
                              _hoisted_19,
                              _createVNode(_component_InputNumber, {
                                modelValue: solarBonItem.newPrice,
                                "onUpdate:modelValue": ($event: any) => ((solarBonItem.newPrice) = $event),
                                placeholder: "0",
                                min: 0,
                                max: 99999999.99,
                                class: "w-full text-sm",
                                onInput: ($event: any) => ($setup.onSolarBonPriceInput($event, solarBonItem))
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "max", "onInput"])
                            ])
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, " Tidak ada data transaksi BBM. "))
              ])
            ])
          ]),
          _: 1
        }, 8, ["visible"])
      ]))
    : _createCommentVNode("", true)
}